import { render, staticRenderFns } from "./SnapQLDebugButton.vue?vue&type=template&id=4ac5fcfb&scoped=true"
import script from "./SnapQLDebugButton.vue?vue&type=script&lang=js"
export * from "./SnapQLDebugButton.vue?vue&type=script&lang=js"
import style0 from "./SnapQLDebugButton.vue?vue&type=style&index=0&id=4ac5fcfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5fcfb",
  null
  
)

export default component.exports